import { maybe } from "@saleor/misc";
import { OrderEventsEnum } from "@saleor/types/globalTypes";

export const isParcelValidated = data =>
  data?.storeOrder?.events.some(
    e => e.type === OrderEventsEnum.STORE_ORDER_SCANNED_BY_OMI_OPS
  );

export const getDeliveryType = data =>
  maybe(() => data?.storeOrder?.order?.shippingMethod?.deliveryType);
